import { component, demoFile } from "system/demo";
import { ReadingListWidget } from 'feature/topic/reading-list';

demoFile('feature/topic/reading-list');

component('ReadingListWidget', ReadingListWidget, {
    state: {
        collections: {
            backlink_article: [
                {
                    key: 'a',
                    title: 'My Article',
                    url: 'https://www.google.com',
                    image: 'https://psi.zdf.de/photos/godzilla_new_york.jpeg',
                    description: 'This is a description of my article',
                    date: '2021-01-01'
                },
                {
                    key: 'b',
                    title: 'An article that has an annoyingly long title',
                    url: 'https://www.google.com',
                    image: 'https://psi.zdf.de/photos/godzilla_new_york.jpeg',
                    date: '2024-01-01'
                }
            ]
        }
    }
}); 